import React from "react";

export default () => (
  <footer>
    <b>email: </b>
    <a href="mailto:info@reverendrainwater.com">info@reverendrainwater.com</a>
    <br />
    <b>cell: </b>206.940.8656
    <div class="copyright">©2019 Susan Rainwater - All Rights Reserved</div>
  </footer>
);
